import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import api from "../servicios/api";
import { authHeaders } from "../servicios/auth";

function ContrasenaWrapper(props) {
    const params = useParams();
    return <Contrasena {...props} params={params} />;
}

class Contrasena extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            datosCargadosusuario: false,
            idusuario: "",
            usuario: "",
            newcontra: "",
            confirmarcontra: "",
            mensaje: "",
            tipoMensaje: "",
            redireccionar: false
        };
    }

    cambioValor = (e) => {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    componentDidMount() {
        const id = this.props.params.id;

        fetch(api + `usuarios/${id}/password`, {
            headers: authHeaders()
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
              const usuario = Array.isArray(datos) ? datos[0] : datos;
            this.setState({
                datosCargadosusuario: true,
                idusuario: usuario.idusuario,
                usuario: usuario.usuario
            });
        })
        .catch(() => {
            this.setState({
                datosCargadosusuario: true,
                mensaje: "Error al cargar el usuario",
                tipoMensaje: "error"
            });
        });
    }

    enviarDatosusuario = (e) => {
        e.preventDefault();

        const { idusuario, newcontra, confirmarcontra } = this.state;

        if (newcontra !== confirmarcontra) {
            this.setState({
                mensaje: "Las contraseñas no coinciden",
                tipoMensaje: "error"
            });
            return;
        }

        if (newcontra.trim() === "") {
            this.setState({
                mensaje: "Debe ingresar una nueva contraseña",
                tipoMensaje: "error"
            });
            return;
        }

        fetch(api + `usuarios/${idusuario}/password`, {
            method: "PUT",
            headers: authHeaders(),
            body: JSON.stringify({
             contra: newcontra
            })
        })
        .then(respuesta => respuesta.json())
        .then(datos => {
            if (datos.success) {
                this.setState({
                    mensaje: "Contraseña actualizada con éxito",
                    tipoMensaje: "success",
                    newcontra: "",
                    confirmarcontra: ""
                });

                setTimeout(() => {
                    this.setState({
                        redireccionar: true
                    });
                }, 1500);
            } else {
                this.setState({
                    mensaje: datos.mensaje || "No se pudo actualizar la contraseña",
                    tipoMensaje: "error"
                });
            }
        })
        .catch(() => {
            this.setState({
                mensaje: "Error de conexión con el servidor",
                tipoMensaje: "error"
            });
        });
    }

    render() {
        const {
            datosCargadosusuario,
            usuario,
            newcontra,
            confirmarcontra,
            mensaje,
            tipoMensaje,
            redireccionar
        } = this.state;

        if (redireccionar) {
            return <Navigate to="/usuarios" />;
        }

        return (
            <div className="card">
                <div className="card-header">
                    CAMBIAR CONTRASEÑA
                </div>

                <div className="card-body">

                    {mensaje && (
                        <div className={`alert ${tipoMensaje === "error" ? "alert-danger" : "alert-success"}`}>
                            {mensaje}
                        </div>
                    )}

                    {datosCargadosusuario ? (
                        <form onSubmit={this.enviarDatosusuario}>

                            <div className="form-group">
                                <label>ID</label>
                                <input
                                    type="text"
                                    name="idusuario"
                                    value={this.state.idusuario}
                                    className="form-control"
                                    readOnly
                                />
                            </div>

                            <div className="form-group">
                                <label>Usuario</label>
                                <input
                                    type="text"
                                    name="usuario"
                                    value={usuario}
                                    className="form-control"
                                    readOnly
                                />
                            </div>

                            <div className="form-group">
                                <label>Nueva Contraseña</label>
                                <input
                                    type="password"
                                    name="newcontra"
                                    onChange={this.cambioValor}
                                    value={newcontra}
                                    className="form-control"
                                />
                            </div>

                            <div className="form-group">
                                <label>Confirmar Contraseña</label>
                                <input
                                    type="password"
                                    name="confirmarcontra"
                                    onChange={this.cambioValor}
                                    value={confirmarcontra}
                                    className="form-control"
                                />
                            </div>

                            <div className="btn-group mt-3" role="group">
                                <button type="submit" className="btn btn-success">
                                    Actualizar contraseña
                                </button>

                                <Link to="/usuarios" className="btn btn-primary">
                                    Cancelar
                                </Link>
                            </div>

                        </form>
                    ) : (
                        <p>Cargando datos...</p>
                    )}
                </div>

                <div className="card-footer text-muted">
                    PMT Chiantla
                </div>
            </div>
        );
    }
}

export default ContrasenaWrapper;